var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.977,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06836 0.125986C7.30198 0.122393 8.93736 1.10156 9.97461 3.06349C10.5793 4.44836 10.6627 5.86499 10.2246 7.31349C9.89805 8.34155 9.50217 9.34155 9.03711 10.3135C8.06386 12.1984 6.98055 14.0109 5.78711 15.751C5.56617 15.9149 5.34742 15.9149 5.13086 15.751C3.83286 13.8854 2.67661 11.927 1.66211 9.87599C0.958234 8.48749 0.531134 7.01874 0.380859 5.46974C0.495134 2.94647 1.7243 1.23814 4.06836 0.344736C4.40617 0.251224 4.73955 0.178311 5.06836 0.125986ZM5.38086 2.81349C6.57073 2.88872 7.35198 3.49288 7.72461 4.62599C7.93455 5.8623 7.48661 6.76855 6.38086 7.34474C4.91405 7.80399 3.86198 7.33524 3.22461 5.93849C2.93955 4.19436 3.6583 3.15271 5.38086 2.81349Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.7f7fbae2cead99a611794addcdf1f62c.svg";
export { ForwardRef as ReactComponent };